import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import en from '../../../international/translations/en';
import CancelWrapper from '../CancelWrapper/CancelWrapper';
import { showCancellationProgress } from '../../../redux/Cancel/subscription';

class CancelSurvey extends Component {
  static propTypes = {
    user: PropTypes.object,
    subscription: PropTypes.object,
    params: PropTypes.object,
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  componentDidMount() {
    this.props.showCancellationProgress(2);
    if (window.analytics) {
      window.analytics.page('Cancel Funnel', 'Reason');
    }
  }

  submitSurvey(submitEvent) {
    const { subscription, match: { params } } = this.props;
    const sub = subscription.currentSubscriptionForBrand;
    const text = en.cancellation_funnel;

    if (submitEvent.preventDefault) {
      // prevent form submit in Firefox, Chrome
      submitEvent.preventDefault();
    } else {
      // prevent form submit in Internet Explorer
      submitEvent.returnValue = false;
    }
    const surveyForm = submitEvent.target;
    if (window.analytics) {
      window.analytics.track('Submitted Cancel Survey', {
        reason: surveyForm.leaving_reason.value,
        feeling: surveyForm.leaving_feeling.value,
        location: 'cancel-funnel-reason',
      });
    }
    if (
      surveyForm.leaving_reason.value === text.survey_reasons.cost &&
      !sub.onTrial
    ) {
      this.context.router.history.push(`/cancel/${params.subscriptionId}/switch-plans`);
    } else {
      this.context.router.history.push(`/cancel/${params.subscriptionId}/verify`);
    }
  }

  skipSurvey = () => {
    if (window.analytics) {
      window.analytics.track('Clicked No Thanks', {
        location: 'cancel-funnel-reason',
      });
    }
    this.context.router.history.push(`/cancel/${this.props.match.params.subscriptionId}/verify`,);
  };

  render() {
    const text = en.cancellation_funnel;
    const reasons = Object.keys(text.survey_reasons)
      .map(key => text.survey_reasons[key]);
    const feelings = Object.keys(text.survey_feelings)
      .map(key => text.survey_feelings[key]);
    return (
      <CancelWrapper splash="survey">
        <Helmet title={text.meta_title_survey} />
        <h1 className="cancel-survey__title">{text.title_survey}</h1>
        <form
          className="cancel-survey__form"
          onSubmit={this.submitSurvey.bind(this)}
          action=""
        >
          <fieldset className="cancel-survey__form__fieldset cancel-survey__form__fieldset--reasons">
            {reasons.map((reason, id) => (
              <label key={`reason_${id}`} htmlFor={`reason_${id}`}>
                <input
                  type="radio"
                  name="leaving_reason"
                  value={reason}
                  id={`reason_${id}`}
                  required
                />
                {reason}
              </label>
            ))}
          </fieldset>
          <fieldset className="cancel-survey__form__fieldset cancel-survey__form__fieldset--feelings">
            <div className="cancel-survey__form__fieldset__legend">{text.survey_feeling_prompt}</div>
            {feelings.map((feeling, id) => (
              <label key={`feeling_${id}`} htmlFor={`feeling_${id}`}>
                <input
                  type="radio"
                  name="leaving_feeling"
                  value={feeling}
                  id={`feeling_${id}`}
                  required
                />
                {feeling}
              </label>
            ))}
          </fieldset>
          <div>
            <button type="submit" className="cancel__button--continue">
              {text.action_survey_continue}
            </button>
            <button onClick={this.skipSurvey} className="cancel__ghost-button">
              {text.action_survey_skip}
            </button>
          </div>
        </form>
      </CancelWrapper>
    );
  }
}

export default connect(state => ({
  user: state.user,
  subscription: state.subscription,
}), { showCancellationProgress })(CancelSurvey);
